import type { FC } from 'react';
import { useIntl } from 'react-intl';

import { CreatePostButton } from '@xing-com/crate-entity-pages-common';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { IconNewChat } from '@xing-com/icons';
import { Menu } from '@xing-com/menu';
import { usePopOver } from '@xing-com/pop-over';

import * as Styled from './create-button.styles';

export const CreateButton: FC = () => {
  const { $t } = useIntl();
  const { pageContext } = usePageContext();
  const popOver = usePopOver();

  const moreButtonClick = () => {
    popOver.handleShow();
  };

  if (!pageContext.pageId) {
    return null;
  }

  return (
    <>
      <Styled.MoreButton
        onClick={moreButtonClick}
        innerRef={popOver.triggerRef}
        size="small"
        aria-label="New Chat"
      >
        <IconNewChat width={20} height={20} />
      </Styled.MoreButton>
      <Menu
        onOutsideClick={popOver.handleHide}
        triggerRef={popOver.triggerRef}
        show={popOver.show}
      >
        <Styled.MoreMenuTitle noMargin size="small">
          {$t({ id: 'EP_ARMSTRONG_CREATE' })}
        </Styled.MoreMenuTitle>
        <Styled.ListWrapper>
          <CreatePostButton page="entity_pages/overview">
            {(onClick: () => void) => (
              <Styled.ListItem
                onClick={() => {
                  popOver.handleHide();
                  // return body to normal overflow
                  document.body.style.overflow = 'visible';
                  onClick();
                }}
              >
                <Styled.Link noMargin size={'small'}>
                  {$t({ id: 'EP_ARMSTRONG_CREATE_POST' })}
                </Styled.Link>
              </Styled.ListItem>
            )}
          </CreatePostButton>
        </Styled.ListWrapper>
      </Menu>
    </>
  );
};
